// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ArticleVideosController from "./article_videos_controller"
application.register("article-videos", ArticleVideosController)

import DanTranhConversionController from "./dan_tranh_conversion_controller"
application.register("dan-tranh-conversion", DanTranhConversionController)

import EgaRegistrationController from "./ega_registration_controller"
application.register("ega-registration", EgaRegistrationController)

import ExternalLinkController from "./external_link_controller"
application.register("external-link", ExternalLinkController)

import FaqAccordionController from "./faq_accordion_controller"
application.register("faq-accordion", FaqAccordionController)

import FacebookVideoController from "./facebook_video_controller"
application.register("facebook-video", FacebookVideoController)

import HeroSliderController from "./hero_slider_controller"
application.register("hero-slider", HeroSliderController)

import PianoConversionController from "./piano_conversion_controller"
application.register("piano-conversion", PianoConversionController)

import PipaConversionController from "./pipa_conversion_controller"
application.register("pipa-conversion", PipaConversionController)

import PromoPopupController from "./promo_popup_controller"
application.register("promo-popup", PromoPopupController)

import ScrollRevealController from "./scroll_reveal_controller"
application.register("scroll-reveal", ScrollRevealController)

import ScrollSliderController from "./scroll_slider_controller"
application.register("scroll-slider", ScrollSliderController)

import TeacherBioController from "./teacher_bio_controller"
application.register("teacher-bio", TeacherBioController)

import TallyAttributionController from "./tally_attribution_controller"
application.register("tally-attribution", TallyAttributionController)
